import { render, staticRenderFns } from "./ChapterDetails.vue?vue&type=template&id=71695436&scoped=true&"
import script from "./ChapterDetails.vue?vue&type=script&lang=js&"
export * from "./ChapterDetails.vue?vue&type=script&lang=js&"
import style0 from "./ChapterDetails.vue?vue&type=style&index=0&id=71695436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71695436",
  null
  
)

export default component.exports